export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/about-service-3.2df3a45f-996c21.png";